import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

export const useIsScrollable = (ref: React.MutableRefObject<HTMLUListElement | null>) => {
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const handleResize = throttle(() => {
      if (ref.current) {
        setIsScrollable(ref.current.scrollWidth > ref.current.clientWidth);
      }
    }, 100);

    handleResize();

    window.addEventListener('resize', handleResize, { passive: true });
    return () => window.removeEventListener('resize', handleResize);
  });

  return isScrollable;
};
